class GenericFilterModelBase {
    FieldName: string = ''
}
export class GenericFilterModelText extends GenericFilterModelBase {
    Value: string = ''
}
export class GenericFilterModelMultiSelect extends GenericFilterModelBase {
    Values: number[] = []
}
